/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateExtractionDto,
  CreateExtractionVersionDto,
  ExtractionDetailDto,
  ExtractionListItemDto,
  ExtractionVersionDetailDto,
  ListExtractionsParams
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListExtractionsUrl = (params: ListExtractionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/extractions?${stringifiedParams}` : `/extractions`
}

export const listExtractions = async (params: ListExtractionsParams, options?: Parameters<typeof customFetch>[1]): Promise<ExtractionListItemDto[]> => {

  return customFetch<ExtractionListItemDto[]>(getListExtractionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExtractionsQueryKey = (params?: ListExtractionsParams,) => {
    return [
    `/extractions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExtractionsQueryOptions = <TData = Awaited<ReturnType<typeof listExtractions>>, TError = unknown>(params: ListExtractionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExtractions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExtractionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExtractions>>> = ({ signal }) => listExtractions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExtractions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExtractionsQueryResult = NonNullable<Awaited<ReturnType<typeof listExtractions>>>
export type ListExtractionsQueryError = unknown


export function useListExtractions<TData = Awaited<ReturnType<typeof listExtractions>>, TError = unknown>(
 params: ListExtractionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExtractions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExtractions>>,
          TError,
          Awaited<ReturnType<typeof listExtractions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExtractions<TData = Awaited<ReturnType<typeof listExtractions>>, TError = unknown>(
 params: ListExtractionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExtractions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExtractions>>,
          TError,
          Awaited<ReturnType<typeof listExtractions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExtractions<TData = Awaited<ReturnType<typeof listExtractions>>, TError = unknown>(
 params: ListExtractionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExtractions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListExtractions<TData = Awaited<ReturnType<typeof listExtractions>>, TError = unknown>(
 params: ListExtractionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExtractions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExtractionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateExtractionUrl = () => {




  return `/extractions`
}

export const createExtraction = async (createExtractionDto: CreateExtractionDto, options?: Parameters<typeof customFetch>[1]): Promise<ExtractionDetailDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ExtractionDetailDto>(getCreateExtractionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createExtractionDto)
  }
);}





export const getCreateExtractionMutationKey = () => ['createExtraction'] as const;

export const getCreateExtractionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExtraction>>, TError,CreateExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExtraction>>, TError,CreateExtractionMutationVariables, TContext> => {

const mutationKey = getCreateExtractionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExtraction>>, CreateExtractionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createExtraction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExtractionMutationResult = NonNullable<Awaited<ReturnType<typeof createExtraction>>>
    export type CreateExtractionMutationBody = CreateExtractionDto
    export type CreateExtractionMutationError = unknown
    export type CreateExtractionMutationVariables = {data: CreateExtractionDto}

    export const useCreateExtraction = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExtraction>>, TError,CreateExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExtraction>>,
        TError,
        CreateExtractionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateExtractionMutationOptions(options), queryClient);
    }
    export const getGetExtractionUrl = (id: string,) => {




  return `/extractions/${id}`
}

export const getExtraction = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ExtractionDetailDto> => {

  return customFetch<ExtractionDetailDto>(getGetExtractionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExtractionQueryKey = (id: string,) => {
    return [
    `/extractions/${id}`
    ] as const;
    }


export const getGetExtractionQueryOptions = <TData = Awaited<ReturnType<typeof getExtraction>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtraction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExtractionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExtraction>>> = ({ signal }) => getExtraction(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExtraction>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExtractionQueryResult = NonNullable<Awaited<ReturnType<typeof getExtraction>>>
export type GetExtractionQueryError = unknown


export function useGetExtraction<TData = Awaited<ReturnType<typeof getExtraction>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtraction>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExtraction>>,
          TError,
          Awaited<ReturnType<typeof getExtraction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExtraction<TData = Awaited<ReturnType<typeof getExtraction>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtraction>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExtraction>>,
          TError,
          Awaited<ReturnType<typeof getExtraction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExtraction<TData = Awaited<ReturnType<typeof getExtraction>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtraction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExtraction<TData = Awaited<ReturnType<typeof getExtraction>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtraction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExtractionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateExtractionVersionUrl = (id: string,) => {




  return `/extractions/${id}/versions`
}

export const createExtractionVersion = async (id: string,
    createExtractionVersionDto: CreateExtractionVersionDto, options?: Parameters<typeof customFetch>[1]): Promise<ExtractionVersionDetailDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ExtractionVersionDetailDto>(getCreateExtractionVersionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createExtractionVersionDto)
  }
);}





export const getCreateExtractionVersionMutationKey = () => ['createExtractionVersion'] as const;

export const getCreateExtractionVersionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExtractionVersion>>, TError,CreateExtractionVersionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExtractionVersion>>, TError,CreateExtractionVersionMutationVariables, TContext> => {

const mutationKey = getCreateExtractionVersionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExtractionVersion>>, CreateExtractionVersionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  createExtractionVersion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExtractionVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createExtractionVersion>>>
    export type CreateExtractionVersionMutationBody = CreateExtractionVersionDto
    export type CreateExtractionVersionMutationError = unknown
    export type CreateExtractionVersionMutationVariables = {id: string;data: CreateExtractionVersionDto}

    export const useCreateExtractionVersion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExtractionVersion>>, TError,CreateExtractionVersionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExtractionVersion>>,
        TError,
        CreateExtractionVersionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateExtractionVersionMutationOptions(options), queryClient);
    }
    export const getArchiveExtractionUrl = (id: string,) => {




  return `/extractions/${id}/archive`
}

export const archiveExtraction = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getArchiveExtractionUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveExtractionMutationKey = () => ['archiveExtraction'] as const;

export const getArchiveExtractionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveExtraction>>, TError,ArchiveExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveExtraction>>, TError,ArchiveExtractionMutationVariables, TContext> => {

const mutationKey = getArchiveExtractionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveExtraction>>, ArchiveExtractionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  archiveExtraction(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveExtractionMutationResult = NonNullable<Awaited<ReturnType<typeof archiveExtraction>>>

    export type ArchiveExtractionMutationError = unknown
    export type ArchiveExtractionMutationVariables = {id: string}

    export const useArchiveExtraction = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveExtraction>>, TError,ArchiveExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveExtraction>>,
        TError,
        ArchiveExtractionMutationVariables,
        TContext
      > => {
      return useMutation(getArchiveExtractionMutationOptions(options), queryClient);
    }
    export const getUnarchiveExtractionUrl = (id: string,) => {




  return `/extractions/${id}/unarchive`
}

export const unarchiveExtraction = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getUnarchiveExtractionUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUnarchiveExtractionMutationKey = () => ['unarchiveExtraction'] as const;

export const getUnarchiveExtractionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveExtraction>>, TError,UnarchiveExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveExtraction>>, TError,UnarchiveExtractionMutationVariables, TContext> => {

const mutationKey = getUnarchiveExtractionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveExtraction>>, UnarchiveExtractionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unarchiveExtraction(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveExtractionMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveExtraction>>>

    export type UnarchiveExtractionMutationError = unknown
    export type UnarchiveExtractionMutationVariables = {id: string}

    export const useUnarchiveExtraction = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveExtraction>>, TError,UnarchiveExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unarchiveExtraction>>,
        TError,
        UnarchiveExtractionMutationVariables,
        TContext
      > => {
      return useMutation(getUnarchiveExtractionMutationOptions(options), queryClient);
    }
